export class TipoEdicao {

    titulo: string;

    constructor(titulo: string) {
        this.titulo = titulo;
    }

    is(tipo: TipoEdicao) {
        return this === tipo;
    }

    isInclusaoAto() {
        return this == INCLUSAO_ATO;
    }

    isCorrecaoAto() {
        return this == CORRECAO_ATO;
    }

    isRepublicacaoAto() {
        return this == REPUBLICACAO_ATO;
    }

    isRepublicacaoAtoComparacao() {
        return this == REPUBLICACAO_ATO_COMPARACAO;
    }

    isCuradoriaAto() {
        return this == CURADORIA_ATO;
    }

    isDuplicacaoAto() {
        return this == DUPLICACAO_ATO;
    }

    isInclusaoTipoAnotacao() {
        return this == INCLUSAO_TIPO_ANOTACAO;
    }

    isEdicaoTipoAnotacao() {
        return this == EDICAO_TIPO_ANOTACAO;
    }

    isCloneTipoAnotacao() {
        return this == CLONE_TIPO_ANOTACAO;
    }

    isVisualizacaoTipoAnotacao() {
        return this == VISUALIZACAO_TIPO_ANOTACAO;
    }

    isVisualizacaoTipoSegmento() {
        return this == VISUALIZACAO_TIPO_SEGMENTO;
    }

    isInclusaoTipoSegmento() {
        return this == INCLUSAO_TIPO_SEGMENTO;
    }

    isEdicaoTipoSegmento() {
        return this == EDICAO_TIPO_SEGMENTO;
    }
}

export const INCLUSAO_ATO = new TipoEdicao('Incluir ato');
export const CURADORIA_ATO = new TipoEdicao('Incluir ato por curadoria');
export const DUPLICACAO_ATO = new TipoEdicao('Incluir ato por duplicação');
export const CORRECAO_ATO = new TipoEdicao('Corrigir ato');
export const REPUBLICACAO_ATO = new TipoEdicao('Republicar ato');
export const REPUBLICACAO_ATO_COMPARACAO = new TipoEdicao('Republicar ato a partir da comparação');

export const INCLUSAO_TIPO_ANOTACAO = new TipoEdicao('Incluir tipo de anotação');
export const EDICAO_TIPO_ANOTACAO = new TipoEdicao('Editar tipo de anotação');
export const CLONE_TIPO_ANOTACAO = new TipoEdicao('Clonar tipo de anotação');
export const VISUALIZACAO_TIPO_ANOTACAO = new TipoEdicao('Visualizar tipo de anotação');

export const INCLUSAO_TIPO_SEGMENTO = new TipoEdicao('Incluir tipo de segmento');
export const EDICAO_TIPO_SEGMENTO = new TipoEdicao('Editar tipo de segmento');
export const VISUALIZACAO_TIPO_SEGMENTO = new TipoEdicao('Visualizar tipo de segmento');
